import { render, staticRenderFns } from "./Vloge.vue?vue&type=template&id=30f3d422&"
import script from "./Vloge.vue?vue&type=script&lang=js&"
export * from "./Vloge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports